export type StepId = 'STEP_1_EnterValues' | 'STEP_2_Confirm';

export const STEP_IDS: StepId[] = ['STEP_1_EnterValues', 'STEP_2_Confirm'];
